import { z } from 'zod/v4';
import { RegistryIdentifierSchema, } from '../customers/index.js';
import { BankAccountZodSchema, PhoneSchema, } from '../index.js';
export const CreateContactSchema = z.object({
    name: z.string().trim().min(1),
    email: z.email().nullish(),
    phone: PhoneSchema.nullish(),
    registryIdentifier: RegistryIdentifierSchema.extend({
        value: z.string().trim().min(1),
    }).nullish(),
    bankAccount: BankAccountZodSchema.nullish(),
});
export const UpdateContactSchema = CreateContactSchema.partial();
//# sourceMappingURL=index.js.map